import { type DigitalGood, DigitalGoodStatus, Visibility } from "../../gql-generated/types";

export const filterVisibilityOptionsByPermissions =
    (permittedVisibilityOptions: readonly Visibility[]) =>
    (options: readonly Visibility[]): Visibility[] => {
        return options.filter((option) => permittedVisibilityOptions.includes(option));
    };

export const filterDoNotShowToSnapchatVisibilityOption =
    (lensForUpdateVisibility?: Visibility) =>
    (options: readonly Visibility[]): Visibility[] => {
        const isLensDistributed =
            lensForUpdateVisibility && lensForUpdateVisibility !== Visibility.VisibilityDontPublishToSnapchat;
        if (isLensDistributed) {
            return options.filter((option) => option !== Visibility.VisibilityDontPublishToSnapchat);
        }

        return [...options];
    };

export const filterOfflineVisilityOption =
    (digitalGoods: readonly DigitalGood[]) =>
    (options: readonly Visibility[]): Visibility[] => {
        const hasActiveDigitalGoods = digitalGoods.some(
            (dg) => dg.status !== DigitalGoodStatus.DigitalGoodStatusInactive,
        );

        if (hasActiveDigitalGoods) {
            return options.filter((option) => option !== Visibility.VisibilityOffline);
        }
        return [...options];
    };

export const filterDistributionVisibilityOptionsBasedOnCurrentVisibility =
    (currentLensVisibility?: Visibility) =>
    (options: readonly Visibility[]): Visibility[] => {
        if (currentLensVisibility === Visibility.VisibilityDontPublishToSnapchat) {
            // can't distribute that lens in the update flow
            return [currentLensVisibility];
        }
        return [...options];
    };

export const mergeFilteredVisibilityOptionsWithCurrentLensVisibility =
    (currentLensVisibility?: Visibility) =>
    (options: readonly Visibility[]): Visibility[] => {
        // if current visibility is the only option - return it
        if (options.length === 0 && currentLensVisibility) {
            return [currentLensVisibility];
        }
        return [...options];
    };

export const sortVisibilityOptions = (options: readonly Visibility[]): Visibility[] => {
    return [...options].sort((a, b) => {
        if (a === Visibility.VisibilityPublic) {
            return -1;
        } else if (b === Visibility.VisibilityPublic) {
            return 1;
        } else if (a === Visibility.VisibilityHidden) {
            return -1;
        } else if (b === Visibility.VisibilityHidden) {
            return 1;
        } else {
            return 0;
        }
    });
};
